export default __webpack_public_path__ + "down_blue_l.png";